import { Alert } from '@/core/tamagoshi/icons/Alert';
import { Text } from '@/core/tamagoshi/Text/Text';
import { getFaqDirection } from '@/domains/proB2BServices/utils/faq/getFaqDirection';
import { FAQS_POST_ID } from '@/domains/productDiscovery/ProductPage/b2b/constants';

import { nonDeductibleVat } from './translations';

import styles from './styles.module.scss';

const faqUrl = getFaqDirection(FAQS_POST_ID);

export const FullVatMention = () => (
  <a
    href={faqUrl}
    className={styles.noDeductionInfo}
    rel="noopener noreferrer"
    target="_blank"
  >
    <Alert width={14} height={14} />
    <Text type="body2" weight="semiBold">
      {nonDeductibleVat}
    </Text>
  </a>
);
